var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"err"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"app-error"},[_c('div',{staticClass:"msg"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }